/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import barchart from '../../custom_lib/AiCharts/adbarchart.vue';
import chartdrill from '../../custom_lib/AiCharts/popupfiles/chartdrillPopup.vue';
import VueApexCharts from "vue3-apexcharts";
import HorizontalPercentageBar from '../../custom_lib/AiCharts/horizondalPercentageBar.vue';
import donutchart from '../../custom_lib/AiCharts/donutchart.vue';
import exportpopup from "./AeExportModal.vue";
import aetablemodel from "../SiteUserDashboard/aetablemodel.vue";
import historytab from '../../custom_lib/AiCharts/historytab.vue';
import subjectdetailsmodal from "./SubjectSafetyModal.vue";
import * as XLSX from "xlsx";
import html2pdf from 'html2pdf.js';
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';

export default {
    name: "SubjectDashboard",
    components: {
        VPagination,
        barchart,
        apexchart: VueApexCharts,
        HorizontalPercentageBar,
        donutchart,
        exportpopup,
        aetablemodel,
        chartdrill,
        historytab,
        subjectdetailsmodal,

    },

    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            defaultdate: "",
            studyId: "",
            sites: [],
            allSites: [],
            drillpopup: false,
            drilldata: [],
            templateId: "",
            gradeChartData: [],
            aetimeline: [],
            aetype: "",
            aetableresult: [],
            showSubjectModal: false,
            subjectFilter: "",
            aetableloading: false,
            openaetable: false,
            aetabletitle: "AE Data",
            aeTimelineCurrentPage: 1,
            showExportModal: false,
            aeTimelinePageSize: 10,
            aeTimelineList: [],
            loader: false,
            causalityChartData: [],
            originalData: [],
            historykeys: ["Home"],
            historydata: {},
            cohortSummary: [],
            searchFilters: {
                siteCode: "",
                subject: "",
                aeTerm: "",
                severity: "All",
                outcome: "All",
                ctcaeGrade: "All"
            },
            severityOptions: [
                "All",
                "MILD",
                "MODERATE",
                "SEVERE"
            ],

            outcomeOptions: [
                "All",
                "RECOVERED/RESOLVED",
                "RECOVERING/RESOLVING",
                "NOT RECOVERED/NOT RESOLVED",
                "RECOVERED/RESOLVED WITH SEQUELAE",
                "FATAL",
                "UNKNOWN"
            ],

            ctcaeGradeOptions: [
                "All",
                "GRADE1",
                "GRADE2",
                "GRADE3",
                "GRADE4",
                "GRADE5"
            ],
            xaxiskeys: {
                piechart: ""
            },
            tilevalues: {
                totalSubjects: 0,
                totalCohorts: 0,
                withdrawnPatients: 0,
                totalAEs: 0,
                grade3PlusAEs: 0,
                saEs: 0,
                susaRs: 0,
                subjectsWithAe: 0,
                subjectsWithAePercentage: 0,
                possiblyRelatedSaes: 0
            },
            causalitySeries: [],
            causalityChartOptions: {
                chart: {
                    type: "donut"
                },
                labels: [],
                legend: {
                    position: "bottom"
                },
                dataLabels: {
                    enabled: true
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " AEs";
                        }
                    }
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: "100%"
                            },
                            legend: {
                                position: "bottom"
                            }
                        }
                    }
                ]
            },
            termCounts : [],
            outcomeCounts: [],

        };
    },
    computed: {

        formattedChartColumns() {

            if (!this.aetimeline?.length) {
                return [];
            }

            const excludedFields = [
                "_id",
                "id",
                "subjectGuid",
                "STUDYID",
                "USUBJID",
                "subjectId",
            ];

            return Object.keys(this.aetimeline[0])
                .filter(key => !excludedFields.includes(key))
                .map(key => {
                    return {
                        value: key,
                        label: key
                            .replace(/([A-Z])/g, " $1")
                            .replace(/^./, str => str.toUpperCase())
                    };
                });
        },

        aeTimelineTotalPages() {

            return Math.ceil(
                this.aeTimelineList.length /
                this.aeTimelinePageSize
            );
        },

        paginatedAeTimeline() {

            const start =
                (this.aeTimelineCurrentPage - 1) *
                this.aeTimelinePageSize;

            const end =
                start + this.aeTimelinePageSize;

            return this.aeTimelineList.slice(start, end);
        }
    },
    async mounted() {
        this.studyId = store.getters.getStudyIs;
        this.defaultdate = localStorage.getItem("dateformat");
        this._studyChangeHandler = async () => {
            this.studyId = store.getters.getStudyIs;
            this.aeTimelineCurrentPage = 1;
            // this.getsites();
            this.getAllSites();
            this.historykeys = ["Home"];
            this.historydata = {};
            this.getSubjectSafetySummary();
            this.getaesummary();
            this.getaetimeline();
        };

        window.addEventListener("studyIdChanged", this._studyChangeHandler);
        // this.getsites();
        this.getAllSites();
        this.getSubjectSafetySummary();
        this.getaesummary();
        this.getaetimeline();
    },
    beforeUnmount() {
        if (this._studyChangeHandler) {
            window.removeEventListener("studyIdChanged", this._studyChangeHandler);
        }
    },

    methods: {

        goBack() {
            this.$router.back();
        },
        handleExport() {

            const excludedFields = ['id', 'subjectGuid'];

            const convertedData = this.aetimeline.map(item => {

                const newItem = {};

                Object.keys(item).forEach(key => {

                    if (excludedFields.includes(key)) {
                        return;
                    }

                    // Convert camelCase -> Pascal Case
                    const pascalKey = key
                        .replace(/([A-Z])/g, ' $1')
                        .replace(/^./, str => str.toUpperCase());

                    newItem[pascalKey] = item[key];
                });

                return newItem;
            });

            const ws = XLSX.utils.json_to_sheet(convertedData);

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                wb,
                ws,
                "Sheet1"
            );

            XLSX.writeFile(
                wb,
                `AE Overview.xlsx`
            );
        },
        async getaesummary() {
            const token = store.getters.getIdToken;

            try {
                const res = await axios.get(
                    `${this.baseapi}/forms/reports/aesummary?studyId=${this.studyId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + token
                        }
                    }
                );

                if (res.data) {

                    this.tilevalues.totalAEs =
                        res.data.totalAEs || 0;

                    this.tilevalues.grade3PlusAEs =
                        res.data.grade3PlusAEs || 0;

                    this.tilevalues.saEs =
                        res.data.saEs || 0;

                    this.tilevalues.susaRs =
                        res.data.susaRs || 0;

                    this.tilevalues.subjectsWithAe =
                        res.data.subjectsWithAe || 0;

                    this.tilevalues.subjectsWithAePercentage =
                        res.data.subjectsWithAePercentage || 0;

                    this.tilevalues.possiblyRelatedSaes =
                        res.data.possiblyRelatedSaes || 0;
                }
            } catch (error) {
                console.error("AE Summary API Error", error);
            }
        },

        async getaetimeline() {
            this.loader = true;
            const token = store.getters.getIdToken;

            try {

                const res = await axios.get(
                    `${this.baseapi}/forms/reports/aetimeline?studyId=${this.studyId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + token
                        }
                    }
                );

                this.originalData = res.data.results || [];
                this.aetimeline = [...this.originalData];
                this.aeTimelineList = [...this.originalData];

                this.prepareGradeChart(this.aetimeline);
                this.prepareCausalityChart(this.aetimeline);
                this.prepareSaeSummary(this.aetimeline);
                this.prepareCohortSummary(this.aetimeline);

                this.historydata["Home"] = this.aetimeline;
                this.historykeys = ["Home"];

            } catch (error) {

                console.error("AE Timeline API Error", error);

            } finally {

                this.loader = false;
            }
        },
        prepareSaeSummary(data) {
            const saeItems = data.filter(x => x.isSerious);

            const result = saeItems.reduce((acc, x) => {
                const term = x.term;
                const outcome = x.outcome;

                // term count
                if (!acc.termCounts[term]) {
                    acc.termCounts[term] = { term, count: 1 };
                } else {
                    acc.termCounts[term].count++;
                }

                // outcome count
                if (!acc.outcomeCounts[outcome]) {
                    acc.outcomeCounts[outcome] = { outcome, count: 1 };
                } else {
                    acc.outcomeCounts[outcome].count++;
                }

                return acc;
            }, { termCounts: {}, outcomeCounts: {} });

            this.termCounts = Object.values(result.termCounts);
            this.outcomeCounts = Object.values(result.outcomeCounts);
        },

        prepareGradeChart(data) {

            this.gradeChartData = data.map(item => {
                return {
                    grade: item.grade,
                    count: item.count,
                };
            });
        },

        prepareCausalityChart(data) {

            const groupedData = {};

            data.forEach(item => {

                const causality =
                    item.causality || "Unknown";

                if (!groupedData[causality]) {

                    groupedData[causality] = 0;
                }

                // each row = 1 AE
                groupedData[causality] += 1;
            });

            this.causalityChartOptions = {
                ...this.causalityChartOptions,
                labels: Object.keys(groupedData)
            };

            this.causalitySeries =
                Object.values(groupedData);
        },

        async drilldowncurrentchartforbar(datafromchild) {
 
            if (!datafromchild || !datafromchild.sortedData) return;
 
            const rawKeyword = datafromchild.filterkeyword || "";

            const match = rawKeyword.match(/^([^(]+)\((.*)\)$/);

            let formattedFilterKeyword = rawKeyword;

            if (match) {

                const fieldName = match[1]
                    .replace(/([A-Z])/g, ' $1')
                    .replace(/^./, str => str.toUpperCase());

                const fieldValue = match[2];

                formattedFilterKeyword =
                    `${fieldName} (${fieldValue})`;
            }

            const lastkey =
                this.historykeys[this.historykeys.length - 1];

            // avoid duplicate consecutive history entries only
            if (lastkey !== formattedFilterKeyword) {

                this.historykeys.push(
                    formattedFilterKeyword
                );
            }

            // always refresh history data
            this.historydata[
                formattedFilterKeyword
            ] = [...datafromchild.sortedData];
 
            this.aetimeline =
                datafromchild.sortedData;
 
            this.aeTimelineList =
                [...this.aetimeline];
 
            this.aeTimelineCurrentPage = 1;
 
            this.prepareGradeChart(this.aetimeline);
            this.prepareCausalityChart(this.aetimeline);
            this.prepareSaeSummary(this.aetimeline);
            this.prepareCohortSummary(this.aetimeline);
        },
 
        loadAeTimelinePage(page) {

            this.aeTimelineCurrentPage = page;
        },

        formatdatetime(date) {

            if (!date) return "-";

            return moment(date).format("DD-MMM-YYYY");
        },
        async getSubjectSafetySummary() {

            const token = store.getters.getIdToken;

            try {

                const res = await axios.get(
                    `${this.baseapi}/management/patient/getsubjectsafetysummary?studyId=${this.studyId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + token
                        }
                    }
                );

                if (res.data) {

                    this.tilevalues.totalSubjects =
                        res.data.enrolledSubject || 0;

                    this.tilevalues.totalCohorts =
                        res.data.totalCohorts || 0;

                    this.tilevalues.withdrawnPatients =
                        res.data.withdrawnPatients || 0;
                }

            } catch (error) {

                console.error(
                    "Subject Safety Summary API Error",
                    error
                );
            }
        },
        handleTableOpen(data) {
            this.drillTableData = data;
            this.showDrillTable = true;
        },

        handleDrilldown({ sortedData, filterkeyword }) {
            this.drillData = sortedData;
            this.drillLabel = filterkeyword;
        },
        prepareCohortSummary(data) {

            const grouped = {};

            data.forEach(item => {
                const cohortName = item.cohortName || "Unknown";
                const cohortCode = item.cohortCode || "Unknown";

                if (!grouped[cohortCode]) {

                    grouped[cohortCode] = {
                        cohortName: cohortName,
                        cohortCode: cohortCode,
                        subjects: new Set(),
                        aeCount: 0,
                        grade3Plus: 0
                    };
                }

                // unique subjects
                grouped[cohortCode].subjects.add(
                    item.subjectGuid
                );

                // AE count
                grouped[cohortCode].aeCount += 1;

                // Grade >=3
                if ((item.gradeValue || 0) >= 3) {

                    grouped[cohortCode].grade3Plus += 1;
                }
            });

            this.cohortSummary =
                Object.values(grouped).map(item => {

                    return {
                        cohortCode: item.cohortCode,
                        cohortName: item.cohortName,
                        subjects: item.subjects.size,
                        aeCount: item.aeCount,
                        grade3Plus: item.grade3Plus
                    };
                });
        },
        exportAeTimeline() {

            this.showExportModal = true;
        },
        showtablepopup(aetype, title) {

            this.aetableresult = [];
            this.aetabletitle = title;
            this.aetype = aetype;
            this.aetableloading = true;
            this.openaetable = true;
        },

        closetablepopup() {

            this.openaetable = false;
            this.aetableloading = false;
        },
        async gotohistorylevel(history) {

            this.deleteAfterKeyarrays(history);

            this.aetimeline =
                this.historydata[history];

            this.aeTimelineList =
                [...this.aetimeline];

            this.aeTimelineCurrentPage = 1;

            this.prepareGradeChart(this.aetimeline);
            this.prepareCausalityChart(this.aetimeline);
            this.prepareSaeSummary(this.aetimeline);
            this.prepareCohortSummary(this.aetimeline);
        },

        async deleteAfterKeyarrays(selectedKey) {

            let index =
                this.historykeys.indexOf(selectedKey);

            if (index !== -1) {

                this.historykeys =
                    this.historykeys.slice(0, index + 1);
            }
        },
        openSubjectModal(type) {
            this.subjectFilter = type;
            this.showSubjectModal = true;
        },
        openDataOverview(data) {

            const excludedFields = ['id', 'subjectGuid'];

            this.drilldata = (data || [])
                .filter(x => x)
                .map(item => {

                    const newItem = {};

                    Object.keys(item).forEach(key => {

                        // Remove unwanted fields
                        if (excludedFields.includes(key)) {
                            return;
                        }

                        // Convert camelCase -> Pascal Case
                        const pascalKey = key
                            .replace(/([A-Z])/g, ' $1')
                            .replace(/^./, str => str.toUpperCase());

                        newItem[pascalKey] = item[key];
                    });

                    return newItem;
                });

            this.drillpopup = true;
        },
//   openDataOverview(data) {

//     this.drilldata = (data || []).filter(x => x);

//     this.drillpopup = true;
// },
        onclosed() {
            this.drillpopup = false;
        },
        async exporttoexcell() {

            const excludedFields = ['id', 'subjectGuid'];

            const convertedData = this.aetimeline.map(item => {

                const newItem = {};

                Object.keys(item).forEach(key => {

                    if (excludedFields.includes(key)) {
                        return;
                    }

                    const pascalKey = key
                        .replace(/([A-Z])/g, ' $1')
                        .replace(/^./, str => str.toUpperCase());

                    newItem[pascalKey] = item[key];
                });

                return newItem;
            });

            const worksheet =
                XLSX.utils.json_to_sheet(convertedData);

            const workbook =
                XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Sheet1"
            );

            XLSX.writeFile(
                workbook,
                "Adverse Events Report.xlsx"
            );
        },
        exporttopdf() {

            const pdfContainer =
                document.createElement('div');

            const captureArea1 =
                this.$refs.captureArea1.cloneNode(true);

            pdfContainer.appendChild(captureArea1);

            if (this.$refs.captureArea2) {

                const captureArea2 =
                    this.$refs.captureArea2.cloneNode(true);

                captureArea2.classList.add('page-break');

                pdfContainer.appendChild(captureArea2);
            }

            pdfContainer.style.width = '100%';
            pdfContainer.style.display = 'block';

            const opt = {
                margin: 0,
                filename: 'Adverse Events Report.pdf',
                image: {
                    type: 'jpeg',
                    quality: 0.98
                },
                html2canvas: {
                    scale: 2
                },
                jsPDF: {
                    unit: 'pt',
                    format: 'a4',
                    orientation: 'landscape'
                }
            };

            html2pdf()
                .set(opt)
                .from(pdfContainer)
                .save();
        },
        filter(data) {
            if (data) {
                return moment(data).format(this.defaultdate);
            }
        },
        applySearchFilters() {

            const filters = this.searchFilters;

            const filteredData = this.originalData.filter(item => {

                const siteCodeMatch =
                    !filters.siteCode ||
                    (item.siteCode || "")
                        .toLowerCase()
                        .includes(filters.siteCode.toLowerCase());

                const subjectMatch =
                    !filters.subject ||
                    (item.subjectId || "")
                        .toLowerCase()
                        .includes(filters.subject.toLowerCase());

                const aeTermMatch =
                    !filters.aeTerm ||
                    (item.term || "")
                        .toLowerCase()
                        .includes(filters.aeTerm.toLowerCase());

                // Severity Dropdown
                const severityMatch =
                    !filters.severity ||
                    filters.severity === "All" ||
                    (item.severity || item.grade || "")
                        .toLowerCase() ===
                    filters.severity.toLowerCase();

                // Outcome Dropdown
                const outcomeMatch =
                    !filters.outcome ||
                    filters.outcome === "All" ||
                    (item.outcome || "")
                        .toLowerCase() ===
                    filters.outcome.toLowerCase();

                // CTCAE Grade Dropdown
                const ctcaeGradeMatch =
                    !filters.ctcaeGrade ||
                    filters.ctcaeGrade === "All" ||
                    (item.grade || "")
                        .toLowerCase() ===
                    filters.ctcaeGrade.toLowerCase();

                return (
                    siteCodeMatch &&
                    subjectMatch &&
                    aeTermMatch &&
                    severityMatch &&
                    outcomeMatch &&
                    ctcaeGradeMatch
                );
            });

            this.aetimeline = [...filteredData];

            this.aeTimelineList = [...filteredData];

            this.aeTimelineCurrentPage = 1;

            this.prepareGradeChart(this.aetimeline);
            this.prepareCausalityChart(this.aetimeline);
            this.prepareSaeSummary(this.aetimeline);
            this.prepareCohortSummary(this.aetimeline);

            this.historykeys = ["Home"];
            this.historydata["Home"] = [...filteredData];
        },
        async getsites() {
            const currentstudy = store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;

            await axios
                .get(
                    `${this.baseapi}/management/site/getallsitesbyuser?studyId=${currentstudy}&sortProperty=siteCode&IsDes=false&getAll=false`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.sites = res.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async getAllSites() {
            const currentstudy = store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;
            await axios
                .get(
                    `${this.baseapi}/management/site/getall?studyId=${currentstudy}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((response) => {
                    this.allSites = response.data;
                    console.log("getallsites");
                })
                .catch((err) => {
                    console.log("failed to get all sites");
                });
        },
    }
};
